import { __ } from '@wordpress/i18n';
import {
  PanelBody,
  SelectControl,
  RangeControl,
} from '@wordpress/components';

const COL_MIN = 1;
const COL_MAX = 6;

export default function DisplayPanel({ attributes, setAttributes }) {
  const { displayMode, columns } = attributes;
  const cols = columns ?? { desktop: 3, tablet: 2, mobile: 1 };

  const updateCol = (key) => (value) =>
    setAttributes({ columns: { ...cols, [key]: value } });

  return (
    <PanelBody title={__('Display', 'brandy-blocks')} initialOpen={true}>
      <SelectControl
        label={__('Layout', 'brandy-blocks')}
        value={displayMode}
        options={[
          { label: __('Grid', 'brandy-blocks'), value: 'grid' },
          { label: __('Slider', 'brandy-blocks'), value: 'slider' },
        ]}
        onChange={(value) => setAttributes({ displayMode: value })}
      />
      {/*
       * No Gap control here: the grid gap is core's Block spacing, under
       * Dimensions, so it comes with the spacing presets and Global Styles.
       * The block's own `gap` attribute stays declared and is still read as
       * the fallback for galleries built before that support existed.
       */}
      <RangeControl
        label={__('Columns (desktop)', 'brandy-blocks')}
        value={cols.desktop}
        min={COL_MIN}
        max={COL_MAX}
        onChange={updateCol('desktop')}
      />
      <RangeControl
        label={__('Columns (tablet)', 'brandy-blocks')}
        value={cols.tablet}
        min={COL_MIN}
        max={COL_MAX}
        onChange={updateCol('tablet')}
      />
      <RangeControl
        label={__('Columns (mobile)', 'brandy-blocks')}
        value={cols.mobile}
        min={COL_MIN}
        max={COL_MAX}
        onChange={updateCol('mobile')}
      />
    </PanelBody>
  );
}
